import { cva, VariantProps } from 'class-variance-authority'
import React from 'react'

import { classes } from '../utils'

export const textAreaVariants = cva(
  [
    '!ring-0 flex w-full rounded-md border border-border-normal bg-transparent px-3 py-2 text-base drop-shadow-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 text-foreground-normal',
    'outline-none focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-focus-outline focus:outline-focus-outline focus:outline-2 focus:outline-offset-[-2px]',
  ],
  {
    variants: {
      size: {
        default: 'min-h-[60px]',
      },
      isInvalid: {
        true: 'focus-visible:outline-border-critical focus:outline-border-critical text-fill-critical',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

export type RawTextAreaProps = React.ComponentPropsWithoutRef<'textarea'> &
  VariantProps<typeof textAreaVariants>

const RawTextarea = React.forwardRef<HTMLTextAreaElement, RawTextAreaProps>(
  ({ className, size, isInvalid, ...props }, ref) => {
    return (
      <textarea
        className={classes(textAreaVariants({ size, isInvalid }), className)}
        ref={ref}
        {...props}
      />
    )
  },
)
RawTextarea.displayName = 'RawTextarea'

export { RawTextarea }
